import type { ICountry } from '@/types/geo';

export const FRANCE_CODE = 'FRA';

export const sortFranceFirst = <T extends { code: string }>(
	items: T[]
): T[] => {
	return [...items].sort((a, b) => {
		if (a.code === FRANCE_CODE) return -1;
		if (b.code === FRANCE_CODE) return 1;
		return 0;
	});
};

export const resolveCountryCode = (
	countryNameOrCode: string,
	countries: ICountry[]
): string => {
	if (!countryNameOrCode) return '';
	const foundCountryByCode = countries.find(
		(c) => c.code === countryNameOrCode
	);
	if (foundCountryByCode) return foundCountryByCode.code;
	const foundCountryByName = countries.find(
		(c) => c.name.toLowerCase() === countryNameOrCode.toLowerCase()
	);
	return foundCountryByName?.code ?? countryNameOrCode;
};
